import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.string.split.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "activity-update"
};
const _hoisted_2 = {
  class: "main"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("红包奖励");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("活动规则设置");

const _hoisted_6 = {
  style: {
    "width": "380px"
  }
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("下单奖励");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("注册奖励");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("客户首营认证奖励");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("按金额");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("按数量");

const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 删除");

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 删除");

const _hoisted_17 = {
  key: 0,
  style: {
    "margin-left": "20px",
    "color": "#999"
  }
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "剩余奖励金额度", -1);

const _hoisted_19 = {
  style: {
    "color": "red"
  }
};
const _hoisted_20 = {
  class: "extra"
};
const _hoisted_21 = {
  class: "wrapper"
};

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "发放规则：", -1);

const _hoisted_23 = /*#__PURE__*/_createTextVNode("活动期间同一客户只发放一次");

const _hoisted_24 = /*#__PURE__*/_createTextVNode("活动期间同一客户累计发放");

const _hoisted_25 = {
  key: 0
};

const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_28 = {
  key: 1
};

const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_31 = {
  class: "flex"
};

const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "~", -1);

const _hoisted_33 = /*#__PURE__*/_createTextVNode("增加");

const _hoisted_34 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_35 = /*#__PURE__*/_createTextVNode("成功开户");

const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "新开户首次下单", -1);

const _hoisted_37 = {
  key: 0,
  style: {
    "margin-left": "15px"
  }
};

const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "首次下单满", -1);

const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_40 = {
  class: "flex"
};

const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "范围：", -1);

const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, "~", -1);

const _hoisted_43 = /*#__PURE__*/_createTextVNode("增加");

const _hoisted_44 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_45 = {
  class: "flex"
};

const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, "~", -1);

const _hoisted_47 = /*#__PURE__*/_createTextVNode("增加");

const _hoisted_48 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 删除");

const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_51 = {
  class: "flex-column"
};

const _hoisted_52 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_53 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_54 = {
  key: 0,
  class: "footer"
};

const _hoisted_55 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_56 = /*#__PURE__*/_createTextVNode("提交");

import { reactive, onMounted, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { activityUpdate, getActivityInfo } from '@/request';
import { arrayRemoveRepeatByProp, isNullOrDefined } from '@/utils';
import BranchModal from './components/branch-modal.vue';
import SupplierModal from './components/supplier-modal.vue';
import MerchandiseModal from './components/merchandise-modal.vue';
import UserModal from './components/user-modal.vue';
import SupplierTreeModal from './components/supplier-tree-modal.vue'; // import VanInputNumber from '@/components/input/input-number.vue';

export default {
  name: 'activity-update',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    let {
      pageType = 'create'
    } = route.query;
    onMounted(() => {
      if (pageType === 'update' || pageType === 'view') {
        getDetail();
      }
    });
    const pageTitle = {
      create: '新建',
      update: '编辑',
      view: '查看'
    };
    const updateDisabled = computed(() => pageType === 'view');

    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    const activityTypes = {
      下单奖励: 'XD',
      开户奖励: 'KH',
      注册奖励: 'ZC',
      客户首营认证奖励: 'SY'
    };
    const activityWays = {
      按金额: 1,
      按数量: 2
    };
    const publisherTypes = {
      发货方: 1,
      控销团队: 2,
      平台: 3
    };

    const activityTimeDisabledDate = date => {
      let oneDayTimeStamp = 24 * 60 * 60 * 1000;
      return new Date(date).getTime() + oneDayTimeStamp < Date.now();
    };

    const form = ref();
    const formData = reactive({
      activityId: undefined,
      activityName: '',
      activityType: 'XD',
      activityWay: 1,
      activityTimeList: [],
      activityPublisherType: undefined,
      totalBonus: undefined,
      remainBonus: undefined,
      branchInfoVoList: [],
      supplierInfoList: [],
      rangeItemAll: 1,
      merchandiseInfoList: [],
      orderRuleVoList: [{
        orderAmount: undefined,
        rangeMin: 1,
        rangeMax: undefined,
        rewardAmount: undefined,
        ladderLevel: 1,
        probability: 100
      }],
      openAccountRuleVo: {
        ruleType: 1,
        orderAmount: 0,
        rewardAmount: 1
      },
      registerRuleVoList: [{
        rangeMin: 1,
        rangeMax: undefined,
        rewardAmount: undefined,
        ladderLevel: 1
      }],
      dzsyRuleVoList: [{
        rangeMin: 1,
        rangeMax: undefined,
        probability: 100,
        ladderLevel: 1
      }],
      activityCondition: 2,
      // 下单奖励活动要求
      activityGrantRule: 1,
      // 下单奖励发放规则
      blacklistVoList: []
    });
    const formRules = {
      activityName: [{
        required: true,
        message: '请填写活动名称',
        trigger: 'blur'
      }],
      activityTimeList: [{
        required: true,
        message: '请选择活动时间',
        trigger: 'change'
      }],
      activityType: [{
        required: true,
        message: '请选择活动类型',
        trigger: 'change'
      }],
      activityWay: [{
        required: true,
        message: '请选择活动方式',
        trigger: 'change'
      }],
      totalBonus: [{
        required: true,
        message: '请填写奖励金额池额度',
        trigger: 'blur'
      }],
      activityPublisherType: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (value === undefined) {
            callback(new Error('请选择活动发起方'));
          } else if (value === publisherTypes['发货方']) {
            Boolean(formData.branchInfoVoList.length) === false && callback(new Error('请选择发货方'));
          } else if (value === publisherTypes['控销团队']) {
            if (formData.activityType === activityTypes['下单奖励']) {
              Boolean(supplierTreeModal.defaultCheckedList.length) === false && callback(new Error('请选择控销团队'));
            } else {
              Boolean(formData.supplierInfoList.length) === false && callback(new Error('请选择控销团队'));
            }
          }

          callback();
        }
      }],
      _activityRule: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          let {
            activityType,
            orderRuleVoList
          } = formData;

          if (activityType === activityTypes['注册奖励']) {
            let validSuccess = formData.registerRuleVoList.every(item => isNullOrDefined(item.rangeMax) === false && isNullOrDefined(item.rewardAmount) === false);
            validSuccess === false && callback('请填写奖励规则');
          } else if (activityType === activityTypes['开户奖励']) {
            let {
              openAccountRuleVo
            } = formData;

            if (openAccountRuleVo.ruleType === 2 && isNullOrDefined(openAccountRuleVo.orderAmount)) {
              callback(new Error('请填写奖励规则'));
            }
          }

          callback();
        }
      }],
      merchandiseInfoList: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.activityType === activityTypes['下单奖励'] && formData.activityPublisherType !== publisherTypes['平台'] && formData.rangeItemAll !== 1) {
            Boolean(formData.merchandiseInfoList.length) === false && callback(new Error('请选择商品范围'));
          }

          callback();
        }
      }],
      'openAccountRuleVo.rewardAmount': [{
        required: true,
        trigger: 'submit',
        message: '请填写奖励金额'
      }]
    }; // 奖励规则-下单奖励表格渲染

    const orderRuleVoListMethod = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      // console.log(row, column, rowIndex, columnIndex)
      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: formData.orderRuleVoList.length,
            colspan: 1
          };
        }

        return {
          rowspan: 0,
          colspan: 0
        };
      }
    }; // 活动详情


    const loading = ref(false);

    function getDetail() {
      loading.value = true;
      getActivityInfo({
        activityId: route.query.activityId
      }).then(res => {
        let {
          activityId,
          activityName,
          activityType,
          activityStartTime,
          activityEndTime,
          activityPublisherType,
          branchInfoVoList,
          supplierInfoList,
          rangeItemAll,
          merchandiseInfoList = [],
          orderRuleVoList,
          openAccountRuleVo,
          registerRuleVoList,
          totalBonus,
          remainBonus,
          activityWay,
          activityCondition,
          activityGrantRule,
          blacklistVoList,
          dzsyRuleVoList
        } = res.data;
        formData.activityId = activityId;
        formData.activityName = activityName;
        formData.activityType = activityType;
        formData.activityWay = activityWay;
        formData.activityTimeList = [activityStartTime, activityEndTime];
        formData.activityPublisherType = activityPublisherType;
        formData.totalBonus = totalBonus;
        formData.remainBonus = remainBonus;
        formData.activityCondition = activityCondition;
        formData.activityGrantRule = activityGrantRule;

        switch (activityPublisherType) {
          case publisherTypes['发货方']:
            formData.branchInfoVoList = branchInfoVoList;
            break;

          case publisherTypes['控销团队']:
            if (formData.activityType === activityTypes['下单奖励']) {
              supplierTreeModal.defaultCheckedList = supplierInfoList;
              supplierTreeModal.defaultChecked = supplierInfoList.map(item => {
                let {
                  supplierId,
                  structureId
                } = item;

                if (structureId) {
                  return `${supplierId}-${structureId}`;
                }

                return supplierId;
              });
            } else {
              formData.supplierInfoList = supplierInfoList;
            }

            break;

          default:
            break;
        }

        if (formData.activityType === activityTypes['下单奖励']) {
          formData.orderRuleVoList = orderRuleVoList;
          formData.rangeItemAll = rangeItemAll;
          formData.merchandiseInfoList = merchandiseInfoList;
          formData.blacklistVoList = blacklistVoList;
        } else if (formData.activityType === activityTypes['注册奖励']) {
          formData.registerRuleVoList = registerRuleVoList;
          formData.rangeItemAll = rangeItemAll;
        } else if (formData.activityType === activityTypes['开户奖励']) {
          formData.openAccountRuleVo = openAccountRuleVo;
        } else {
          formData.blacklistVoList = blacklistVoList;
          formData.dzsyRuleVoList = dzsyRuleVoList;
        }
      }).finally(() => {
        loading.value = false;
      });
    } // 表格相关业务


    function addOrderRuleTableRowHandle() {
      let {
        orderRuleVoList
      } = formData;
      let ladderLevel = orderRuleVoList.length + 1;
      let preRangeMax = orderRuleVoList[orderRuleVoList.length - 1].rangeMax;
      const tableRowTpl = {
        ladderLevel,
        orderAmount: undefined,
        rangeMin: isNaN(preRangeMax) ? undefined : preRangeMax + 1,
        rangeMax: undefined,
        rewardAmount: undefined
      };

      if (orderRuleVoList.length < 5) {
        orderRuleVoList.push(tableRowTpl);
      }
    }

    function removeOrderRuleTableRowHandle() {
      if (formData.orderRuleVoList.length > 1) {
        formData.orderRuleVoList.pop();
      }
    }

    function addRegisterRuleTableHandle() {
      let {
        registerRuleVoList
      } = formData;
      let ladderLevel = registerRuleVoList.length + 1;
      let preRangeMax = registerRuleVoList[registerRuleVoList.length - 1].rangeMax;
      const tableRowTpl = {
        ladderLevel,
        rangeMin: isNaN(preRangeMax) ? undefined : preRangeMax,
        rangeMax: undefined,
        rewardAmount: undefined,
        probability: 0
      };
      formData.registerRuleVoList.push(tableRowTpl); // if (formData.registerRuleVoList.length < 5) {
      //     formData.registerRuleVoList.push(tableRowTpl);
      // }
    }

    function removeResgisterRuleTableRowHandle() {
      if (formData.registerRuleVoList.length > 1) {
        formData.registerRuleVoList.pop();
      }
    }

    function getTableData() {
      console.log(formData.orderRuleVoList);
    }

    function orderRuleRangeMaxChangeHandle(value, $index) {
      let orderRuleVoList = formData.orderRuleVoList;

      if ($index < orderRuleVoList.length - 1) {
        // orderRuleVoList[$index + 1]['rangeMin'] = value + 1;
        orderRuleVoList[$index + 1]['rangeMin'] = value;
      }
    }

    function registerRuleRangeMaxChangeHandle(value, $index) {
      let registerRuleVoList = formData.registerRuleVoList;

      if ($index < registerRuleVoList.length - 1) {
        registerRuleVoList[$index + 1]['rangeMin'] = value + 1; // registerRuleVoList[$index + 1]['rangeMin'] = value;
      }
    }
    /**
     * 活动发起方，
     */


    function selectPublisherHandle() {
      switch (formData.activityPublisherType) {
        case publisherTypes['发货方']:
          branchModal.visible = true;
          branchModal.selectedBranchIds = formData.branchInfoVoList.map(v => v.branchId.toString());
          break;

        case publisherTypes['控销团队']:
          if (formData.activityType === activityTypes['下单奖励']) {
            supplierTreeModal.visible = true;
          } else {
            supplierModal.visible = true;
            branchModal.selectedSupplierIds = formData.supplierInfoList.map(v => v.supplierId);
          }

          break;

        default:
          break;
      }
    }

    const branchModal = reactive({
      visible: false,
      selectedBranchIds: []
    });
    const supplierModal = reactive({
      visible: false,
      selectedSupplierIds: []
    });

    function selectBranchSuccessHandle(branchList) {
      let list = [...branchList, ...formData.branchInfoVoList];
      formData.branchInfoVoList = arrayRemoveRepeatByProp(list, 'branchId');
    }

    function selectSupplierSuccessHandle(supplierList) {
      let list = [...supplierList, ...formData.supplierInfoList];
      formData.supplierInfoList = arrayRemoveRepeatByProp(list, 'supplierId');
    }

    function selectMerchandiseSuccessHandle(merchandiseList) {
      let list = [...merchandiseList, ...formData.merchandiseInfoList];
      formData.merchandiseInfoList = arrayRemoveRepeatByProp(list, 'prodNo');
    } // 商品范围


    const selectMerchandiseDisabled = computed(() => {
      if (updateDisabled.value) {
        return true;
      }

      if (formData.activityPublisherType === publisherTypes['发货方']) {
        return formData.branchInfoVoList.length === 0;
      }

      if (formData.activityPublisherType === publisherTypes['控销团队']) {
        return formData.supplierInfoList.length === 0;
      }

      return true;
    });
    const merchandiseModal = reactive({
      visible: false,
      selectedMerchandises: []
    });

    function selectMerchandiseHandle() {
      merchandiseModal.visible = true;
      merchandiseModal.selectedMerchandises = formData.merchandiseInfoList.map(v => v.prodNo);
    } // 校验与提交


    function submit() {
      form.value.validate().then(valid => {
        if (valid) {
          fetchHandle();
        }
      });

      const fetchHandle = () => {
        let body = {
          activityId: formData.activityId,
          activityName: formData.activityName,
          activityStartTime: formData.activityTimeList[0],
          activityEndTime: formData.activityTimeList[1],
          activityType: formData.activityType,
          activityPublisherType: formData.activityPublisherType,
          totalBonus: formData.totalBonus
        };

        switch (formData.activityPublisherType) {
          case publisherTypes['发货方']:
            body.branchInfoVoList = formData.branchInfoVoList.map(v => ({
              branchId: v.branchId
            }));
            break;

          case publisherTypes['控销团队']:
            if (formData.activityType === activityTypes['下单奖励']) {
              body.supplierInfoList = supplierTreeModal.defaultCheckedList;
            } else {
              body.supplierInfoList = formData.supplierInfoList.map(v => ({
                supplierId: v.supplierId
              }));
            }

            break;

          default:
            break;
        }

        if (formData.activityType === activityTypes['下单奖励']) {
          let {
            orderRuleVoList
          } = formData;
          orderRuleVoList.forEach((item, index, _this) => {
            item.orderAmount = _this[0].orderAmount;
          });
          body.orderRuleVoList = orderRuleVoList;
          body.rangeItemAll = formData.rangeItemAll;
          body.merchandiseInfoList = formData.merchandiseInfoList.map(v => ({
            prodNo: v.prodNo
          }));
          body.activityWay = formData.activityWay;
          body.activityCondition = formData.activityCondition;
          body.activityGrantRule = formData.activityGrantRule;
          body.blacklistVoList = formData.blacklistVoList; // 校验金额区间规则，概率相加== 100

          if (!body.orderRuleVoList[0].orderAmount) {
            ElMessage.error('缺少单笔订单金额');
            return;
          }

          for (let i = 0; i < body.orderRuleVoList.length; i++) {
            let currentData = body.orderRuleVoList[i];

            if (currentData.rangeMin == undefined || currentData.rangeMax == undefined) {
              ElMessage.error('奖励金额区间不正确');
              return;
            }

            if (currentData.rangeMin > currentData.rangeMax) {
              ElMessage.error('奖励金额区间不正确');
              return;
            }

            if (i > 0) {
              let parentData = body.orderRuleVoList[i - 1];

              if (currentData.rangeMin < parentData.rangeMax) {
                ElMessage.error('奖励金额区间不正确');
                return;
              }
            }
          }

          let percentList = body.orderRuleVoList.map(v => v.probability).filter(Boolean);
          let percentTotal = percentList.reduce((pre, cur) => pre + cur, 0);

          if (percentTotal !== 100) {
            ElMessage.error('奖励金额概率累加需为100%');
            return;
          }
        } else if (formData.activityType === activityTypes['注册奖励']) {
          body.registerRuleVoList = formData.registerRuleVoList;
          body.rangeItemAll = formData.rangeItemAll;
        } else if (formData.activityType === activityTypes['开户奖励']) {
          body.openAccountRuleVo = formData.openAccountRuleVo;
        } else if (formData.activityType === activityTypes['客户首营认证奖励']) {
          body.blacklistVoList = formData.blacklistVoList;
          body.dzsyRuleVoList = formData.dzsyRuleVoList; // 校验金额区间规则，概率相加== 100

          for (let i = 0; i < body.dzsyRuleVoList.length; i++) {
            let currentData = body.dzsyRuleVoList[i];

            if (currentData.rangeMin == undefined || currentData.rangeMax == undefined) {
              ElMessage.error('奖励金额区间不正确');
              return;
            }

            if (currentData.rangeMin > currentData.rangeMax) {
              ElMessage.error('奖励金额区间不正确');
              return;
            }

            if (i > 0) {
              let parentData = body.dzsyRuleVoList[i - 1];

              if (currentData.rangeMin < parentData.rangeMax) {
                ElMessage.error('奖励金额区间不正确');
                return;
              }
            }
          }

          let percentList = body.dzsyRuleVoList.map(v => v.probability).filter(Boolean);
          let percentTotal = percentList.reduce((pre, cur) => pre + cur, 0);

          if (percentTotal !== 100) {
            ElMessage.error('奖励金额概率累加需为100%');
            return;
          }
        }

        activityUpdate(body).then(res => {
          let {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success(msg);
            goBack();
            return true;
          }

          ElMessage.error(msg);
          return false;
        });
      };
    } // 活动类型change


    function activityTypeChangeHandle() {
      form.value.clearValidate();

      if (formData.activityType === activityTypes['客户首营认证奖励']) {
        formData.activityPublisherType = publisherTypes['平台'];
      } else {
        formData.activityPublisherType = undefined;
      }
    } // 已选择列表simple-table 删除方法


    function simpleTableDeleteHandle(formDataKey, key, data) {
      let targetList = [...formData[formDataKey]];
      let removeIndex = targetList.findIndex(v => v[key] === data[key]);
      targetList.splice(removeIndex, 1);
      formData[formDataKey] = targetList; // 删除了发货方或者控销团队，重新选择商品

      if (formDataKey === 'branchInfoVoList' || formDataKey === 'supplierInfoList') {
        formData.merchandiseInfoList = [];
      }
    } // 活动方式变更，奖励规则单笔订单满字段orderAmount置空


    function activityWayChangeHandle() {
      formData.orderRuleVoList.forEach(item => {
        item.orderAmount = undefined;
      });
    } // 电子首页认证奖励相关


    function dzsyRuleRangeMaxChangeHandle(value, $index) {
      let dzsyRuleVoList = formData.dzsyRuleVoList;

      if ($index < dzsyRuleVoList.length - 1) {
        dzsyRuleVoList[$index + 1]['rangeMin'] = value;
      }
    }

    function addDzsyRuleTableHandle() {
      let {
        dzsyRuleVoList
      } = formData;
      let ladderLevel = dzsyRuleVoList.length + 1;
      let preRangeMax = dzsyRuleVoList[dzsyRuleVoList.length - 1].rangeMax;
      const tableRowTpl = {
        ladderLevel,
        rangeMin: isNaN(preRangeMax) ? undefined : preRangeMax,
        rangeMax: undefined,
        probability: 0
      };
      formData.dzsyRuleVoList.push(tableRowTpl); // if (formData.dzsyRuleVoList.length < 5) {
      //     formData.dzsyRuleVoList.push(tableRowTpl);
      // }
    }

    function removeDzsyRuleTableRowHandle() {
      if (formData.dzsyRuleVoList.length > 1) {
        formData.dzsyRuleVoList.pop();
      }
    }

    const userModal = reactive({
      visible: false
    }); // 下单奖励控销tree团队

    const supplierTreeModal = reactive({
      visible: false,
      defaultChecked: [],
      defaultCheckedList: []
    });

    function getSelectedSupplier(e) {
      if (e.length === 0) return;
      supplierTreeModal.defaultCheckedList = e.map(item => {
        let obj = {};
        let idList = item.id.split('-');

        if (idList.length > 1) {
          obj.supplierId = idList[0];
          obj.structureId = idList[1];
        } else {
          obj.supplierId = idList[0];
        }

        if (item.pid) {
          obj.parentId = item.pid;
        }

        return obj;
      });
      supplierTreeModal.defaultChecked = e.map(v => v.id);
    }

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_divider = _resolveComponent("el-divider");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form = _resolveComponent("el-form");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(pageTitle[_unref(pageType)]) + "红包活动", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: goBack
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: formData,
        rules: formRules,
        "label-position": "right",
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "活动名称",
          prop: "activityName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.activityName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.activityName = $event),
            placeholder: "请输入活动名称",
            style: {
              "width": "380px"
            },
            disabled: _unref(updateDisabled),
            maxlength: 25
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动时间",
          prop: "activityTimeList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_date_picker, {
            modelValue: formData.activityTimeList,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.activityTimeList = $event),
            type: "datetimerange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "disabled-date": activityTimeDisabledDate,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"])])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动类型",
          prop: "activityType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.activityType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.activityType = $event),
            disabled: _unref(updateDisabled),
            onChange: activityTypeChangeHandle
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: activityTypes['下单奖励']
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_radio, {
              label: activityTypes['注册奖励']
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_radio, {
              label: activityTypes['客户首营认证奖励']
            }, {
              default: _withCtx(() => [_hoisted_9]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        }), formData.activityType === activityTypes['下单奖励'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "活动方式",
          prop: "activityWay"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.activityWay,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.activityWay = $event),
            disabled: _unref(updateDisabled),
            onChange: activityWayChangeHandle
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: activityWays['按金额']
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_radio, {
              label: activityWays['按数量']
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "活动发起方",
          prop: "activityPublisherType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: formData.activityPublisherType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.activityPublisherType = $event),
            style: {
              "width": "100px"
            },
            disabled: _unref(updateDisabled),
            onChange: _cache[5] || (_cache[5] = () => {
              formData.merchandiseInfoList = [];
            })
          }, {
            default: _withCtx(() => [formData.activityType === activityTypes['下单奖励'] ? (_openBlock(), _createBlock(_component_el_option, {
              key: 0,
              label: "发货方",
              value: publisherTypes['发货方']
            }, null, 8, ["value"])) : _createCommentVNode("", true), formData.activityType === activityTypes['下单奖励'] || formData.activityType === activityTypes['注册奖励'] ? (_openBlock(), _createBlock(_component_el_option, {
              key: 1,
              label: "控销团队",
              value: publisherTypes['控销团队']
            }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(_component_el_option, {
              label: "平台",
              value: publisherTypes['平台']
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["modelValue", "disabled"]), formData.activityPublisherType && formData.activityPublisherType !== publisherTypes['平台'] ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [!_unref(updateDisabled) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            style: {
              "margin-left": "10px"
            },
            onClick: selectPublisherHandle
          }, {
            default: _withCtx(() => [formData.activityType === activityTypes['注册奖励'] ? (_openBlock(), _createElementBlock("span", _hoisted_12, "添加")) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(supplierTreeModal.defaultCheckedList.length ? '已设置' : '设置'), 1))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            style: {
              "margin-left": "10px"
            },
            onClick: selectPublisherHandle
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          }))], 64)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: ""
        }, {
          default: _withCtx(() => [formData.activityPublisherType === publisherTypes['发货方'] && formData.branchInfoVoList.length ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: formData.branchInfoVoList,
            style: {
              "width": "360px"
            },
            "max-height": "250",
            class: "simple-table"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "发货方名称",
              prop: "branchName"
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "100px"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                disabled: _unref(updateDisabled),
                onClick: $event => simpleTableDeleteHandle('branchInfoVoList', 'branchId', scope.row)
              }, {
                default: _withCtx(() => [_hoisted_15]),
                _: 2
              }, 1032, ["disabled", "onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])) : formData.activityPublisherType === publisherTypes['控销团队'] && formData.activityType === activityTypes['注册奖励'] && formData.supplierInfoList.length ? (_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: formData.supplierInfoList,
            style: {
              "width": "360px"
            },
            "max-height": "250",
            class: "simple-table"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "控销团队名称",
              prop: "supplierName"
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "100px"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                disabled: _unref(updateDisabled),
                onClick: $event => simpleTableDeleteHandle('supplierInfoList', 'supplierId', scope.row)
              }, {
                default: _withCtx(() => [_hoisted_16]),
                _: 2
              }, 1032, ["disabled", "onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "奖励金额池",
          prop: "totalBonus"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: formData.totalBonus,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.totalBonus = $event),
            min: 1,
            max: 100000,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"]), _unref(pageType) !== 'create' ? (_openBlock(), _createElementBlock("span", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, "￥" + _toDisplayString(formData.remainBonus), 1)])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: formData.activityType === activityTypes['客户首营认证奖励'] ? '奖励金额' : '奖励规则',
          prop: "_activityRule"
        }, {
          default: _withCtx(() => [formData.activityType === activityTypes['下单奖励'] ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_el_radio_group, {
            modelValue: formData.activityGrantRule,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.activityGrantRule = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_23]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_24]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])])]), _createVNode(_component_el_table, {
            data: formData.orderRuleVoList,
            spanMethod: orderRuleVoListMethod,
            border: "",
            width: "1000"
          }, {
            append: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: addOrderRuleTableRowHandle,
              style: {
                "margin-left": "15px"
              },
              disabled: _unref(updateDisabled)
            }, {
              default: _withCtx(() => [_hoisted_33]),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: removeOrderRuleTableRowHandle,
              disabled: _unref(updateDisabled)
            }, {
              default: _withCtx(() => [_hoisted_34]),
              _: 1
            }, 8, ["disabled"])]),
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "ladderLevel",
              label: "阶梯",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              prop: "orderAmount",
              label: "单笔订单",
              width: "250"
            }, {
              default: _withCtx(scope => [formData.activityWay === activityWays['按金额'] ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, _createVNode(_component_el_input_number, {
                modelValue: scope.row.orderAmount,
                "onUpdate:modelValue": $event => scope.row.orderAmount = $event,
                min: 1,
                max: 100000,
                style: {
                  "margin": "0 10px"
                },
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_27])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createVNode(_component_el_input_number, {
                modelValue: scope.row.orderAmount,
                "onUpdate:modelValue": $event => scope.row.orderAmount = $event,
                min: 1,
                max: 100000,
                style: {
                  "margin": "0 10px"
                },
                "step-strictly": true,
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_30]))]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "rangeMin",
              label: "奖励金额区间（元）",
              width: "320"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_31, [_createVNode(_component_el_input_number, {
                modelValue: scope.row.rangeMin,
                "onUpdate:modelValue": $event => scope.row.rangeMin = $event,
                min: 0,
                precision: 1,
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_32, _createVNode(_component_el_input_number, {
                modelValue: scope.row.rangeMax,
                "onUpdate:modelValue": $event => scope.row.rangeMax = $event,
                min: scope.row.rangeMin,
                precision: 1,
                onChange: v => {
                  orderRuleRangeMaxChangeHandle(v, scope.$index);
                },
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "onChange", "disabled"])])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "probability",
              label: "概率（%）",
              width: "240"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.probability,
                "onUpdate:modelValue": $event => scope.row.probability = $event,
                min: 0,
                max: 100,
                precision: 0,
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])], 64)) : formData.activityType === activityTypes['开户奖励'] ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_radio_group, {
            modelValue: formData.openAccountRuleVo.ruleType,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.openAccountRuleVo.ruleType = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_35]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_36]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"]), formData.openAccountRuleVo.ruleType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_hoisted_38, formData.openAccountRuleVo.ruleType === 2 ? (_openBlock(), _createBlock(_component_el_input_number, {
            key: 0,
            type: "number",
            min: 0,
            max: 100000,
            modelValue: formData.openAccountRuleVo.orderAmount,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.openAccountRuleVo.orderAmount = $event),
            style: {
              "width": "160px",
              "margin": "0 10px"
            },
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"])) : _createCommentVNode("", true), _hoisted_39])) : _createCommentVNode("", true)], 64)) : formData.activityType === activityTypes['注册奖励'] ? (_openBlock(), _createBlock(_component_el_table, {
            key: 2,
            data: formData.registerRuleVoList,
            border: "",
            width: "1000"
          }, {
            append: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: addRegisterRuleTableHandle,
              style: {
                "margin-left": "15px"
              },
              disabled: _unref(updateDisabled)
            }, {
              default: _withCtx(() => [_hoisted_43]),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: removeResgisterRuleTableRowHandle,
              disabled: _unref(updateDisabled)
            }, {
              default: _withCtx(() => [_hoisted_44]),
              _: 1
            }, 8, ["disabled"])]),
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "ladderLevel",
              label: "阶梯",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              prop: "rangeMin",
              label: "推广注册数量",
              width: "320"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_40, [_hoisted_41, _createVNode(_component_el_input, {
                type: "number",
                modelValue: scope.row.rangeMin,
                "onUpdate:modelValue": $event => scope.row.rangeMin = $event,
                disabled: "",
                style: {
                  "width": "80px"
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _hoisted_42, _createVNode(_component_el_input_number, {
                modelValue: scope.row.rangeMax,
                "onUpdate:modelValue": $event => scope.row.rangeMax = $event,
                min: scope.row.rangeMin,
                "step-strictly": true,
                onChange: v => {
                  registerRuleRangeMaxChangeHandle(v, scope.$index);
                },
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "onChange", "disabled"])])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "rewardAmount",
              label: "奖励金额",
              width: "240"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.rewardAmount,
                "onUpdate:modelValue": $event => scope.row.rewardAmount = $event,
                min: 1,
                max: 100,
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])) : (_openBlock(), _createBlock(_component_el_table, {
            key: 3,
            data: formData.dzsyRuleVoList,
            border: "",
            width: "1000"
          }, {
            append: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: addDzsyRuleTableHandle,
              style: {
                "margin-left": "15px"
              },
              disabled: _unref(updateDisabled)
            }, {
              default: _withCtx(() => [_hoisted_47]),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: removeDzsyRuleTableRowHandle,
              disabled: _unref(updateDisabled)
            }, {
              default: _withCtx(() => [_hoisted_48]),
              _: 1
            }, 8, ["disabled"])]),
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "ladderLevel",
              label: "阶梯",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              prop: "rangeMin",
              label: "奖励金额区间（元）",
              width: "320"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_input_number, {
                modelValue: scope.row.rangeMin,
                "onUpdate:modelValue": $event => scope.row.rangeMin = $event,
                min: 0,
                precision: 1,
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_46, _createVNode(_component_el_input_number, {
                modelValue: scope.row.rangeMax,
                "onUpdate:modelValue": $event => scope.row.rangeMax = $event,
                min: scope.row.rangeMin,
                precision: 1,
                onChange: v => {
                  dzsyRuleRangeMaxChangeHandle(v, scope.$index);
                },
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "onChange", "disabled"])])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "probability",
              label: "概率（%）",
              width: "240"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.probability,
                "onUpdate:modelValue": $event => scope.row.probability = $event,
                min: 0,
                max: 100,
                precision: 0,
                disabled: _unref(updateDisabled)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"]))]),
          _: 1
        }, 8, ["label"]), formData.activityType === activityTypes['下单奖励'] && formData.activityPublisherType !== publisherTypes['平台'] && false ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_form_item, {
          label: "商品范围",
          prop: "merchandiseInfoList"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: formData.rangeItemAll,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.rangeItemAll = $event),
            style: {
              "width": "120px",
              "margin-right": "10px"
            },
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "指定商品",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "全部商品",
              value: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"]), formData.rangeItemAll != undefined ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: selectMerchandiseHandle,
            disabled: _unref(selectMerchandiseDisabled)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(formData.rangeItemAll === 0 ? '设置白名单' : '设置黑名单'), 1)]),
            _: 1
          }, 8, ["disabled"])) : _createCommentVNode("", true)]),
          _: 1
        }), formData.merchandiseInfoList.length ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: formData.merchandiseInfoList,
            style: {
              "width": "360px"
            },
            "max-height": "250",
            class: "simple-table"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "商品名称",
              prop: "prodName"
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "100px"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                disabled: _unref(updateDisabled),
                onClick: $event => simpleTableDeleteHandle('merchandiseInfoList', 'prodNo', scope.row)
              }, {
                default: _withCtx(() => [_hoisted_49]),
                _: 2
              }, 1032, ["disabled", "onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), formData.activityType === activityTypes['开户奖励'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: "奖励金额",
          prop: "openAccountRuleVo.rewardAmount"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: formData.openAccountRuleVo.rewardAmount,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.openAccountRuleVo.rewardAmount = $event),
            min: 1,
            max: 100,
            style: {
              "margin-right": "10px"
            },
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"]), _hoisted_50]),
          _: 1
        })) : _createCommentVNode("", true), formData.activityType === activityTypes['下单奖励'] || formData.activityType === activityTypes['客户首营认证奖励'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          label: "黑名单"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [!_unref(updateDisabled) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "small",
            style: {
              "width": "60px"
            },
            onClick: _cache[12] || (_cache[12] = $event => userModal.visible = true)
          }, {
            default: _withCtx(() => [_hoisted_52]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_table, {
            data: formData.blacklistVoList,
            size: "small"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "用户名称",
              prop: "linkMan",
              width: "200px"
            }), !_unref(updateDisabled) ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              prop: "accountId"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: $event => formData.blacklistVoList.splice(scope.$index, 1)
              }, {
                default: _withCtx(() => [_hoisted_53]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["data"])])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])]), !_unref(updateDisabled) ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [_hoisted_55]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_56]),
        _: 1
      })])) : _createCommentVNode("", true), _createVNode(BranchModal, {
        modelValue: branchModal.visible,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => branchModal.visible = $event),
        selectedBranchIds: branchModal.selectedBranchIds,
        onSuccess: selectBranchSuccessHandle
      }, null, 8, ["modelValue", "selectedBranchIds"]), _createVNode(SupplierModal, {
        modelValue: supplierModal.visible,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => supplierModal.visible = $event),
        selectedSupplierIds: branchModal.selectedSupplierIds,
        onSuccess: selectSupplierSuccessHandle
      }, null, 8, ["modelValue", "selectedSupplierIds"]), _createVNode(MerchandiseModal, {
        modelValue: merchandiseModal.visible,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => merchandiseModal.visible = $event),
        publishType: formData.activityPublisherType,
        branches: formData.branchInfoVoList,
        suppliers: formData.supplierInfoList,
        selectedMerchandises: merchandiseModal.selectedMerchandises,
        onSuccess: selectMerchandiseSuccessHandle
      }, null, 8, ["modelValue", "publishType", "branches", "suppliers", "selectedMerchandises"]), _createVNode(UserModal, {
        modelValue: userModal.visible,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => userModal.visible = $event),
        selectedList: formData.blacklistVoList,
        onSuccess: _cache[17] || (_cache[17] = selectedList => formData.blacklistVoList = selectedList)
      }, null, 8, ["modelValue", "selectedList"]), _createVNode(SupplierTreeModal, {
        modelValue: supplierTreeModal.visible,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => supplierTreeModal.visible = $event),
        defaultChecked: supplierTreeModal.defaultChecked,
        disabled: _unref(updateDisabled),
        onSuccess: getSelectedSupplier
      }, null, 8, ["modelValue", "defaultChecked", "disabled"])])), [[_directive_loading, loading.value]]);
    };
  }

};